module.exports = __webpack_public_path__ + "img/banner_mobile_dorada.072e3e3f.jpg";